Ext.define('SA.EditLocationLabel', {
    singleton: true,

    tpl: new Ext.XTemplate(
        '<tpl if="isCombination || isRadius">',
            '<svg class="sa-edit-location-label-icon">',
                '<tpl if="isCombination">',
                    '<use href="#sa-icon-combination-location"></use>',
                '<tpl else>',
                    '<use href="#sa-icon-radius-location"></use>',
                '</tpl>',
            '</svg>',
        '</tpl>',
        '{location:locationRenderer}'
    ),

    get(id) {
        var location = SA.data.LocationsCache.get(id),
            isRadius = location.type === 'radius',
            isCombination = location.type === 'combination';

        return this.tpl.apply({location, isRadius, isCombination});
    }
});